// extracted by mini-css-extract-plugin
export default {"button":"RescheduledButton_button__OArob"};